import { render, staticRenderFns } from "./SpaceTemplateRoot.vue?vue&type=template&id=3d1d5256"
import script from "./SpaceTemplateRoot.vue?vue&type=script&lang=ts"
export * from "./SpaceTemplateRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports